import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyC_SOSlex7zugm87gFb4E77fLeOT97YqGc",
  authDomain: "formmesto.firebaseapp.com",
  projectId: "formmesto",
  storageBucket: "formmesto.appspot.com",
  messagingSenderId: "1027781037174",
  appId: "1:1027781037174:web:3cd9ed8bd0415715cfa357"
};

// Initialize 
const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp);

export default firebaseApp 